/**
 * URL search params shape for the /search route.
 * Extracted from the implicit shape used by search.lazy.tsx consumers.
 */
export type SearchRouteSearch = {
  query?: string;
  venue?: string;
  space?: string;
  latitude?: string;
  longitude?: string;
  types?: string;
  accessibilities?: string;
  accessibility_sections?: string;
  zoom?: string;
  saved_place_id?: string;
  saved_place_user_id?: string;
  saved_place_sortby?: string;
  placesToReplaceString?: string;
  simpleLocationText?: string;
  includeGoogleFallback?: string;
  openingHoursMode?: "any" | "open_now" | "custom";
  openingHoursDay?: string;
  openingHoursTime?: string;
  section_filter?: string;
  mapper_category?: string;
};

export function searchParamsSchema(
  raw: Record<string, unknown>,
): SearchRouteSearch {
  return {
    query: raw.query as string | undefined,
    venue: raw.venue as string | undefined,
    space: raw.space as string | undefined,
    latitude: raw.latitude as string | undefined,
    longitude: raw.longitude as string | undefined,
    types: raw.types as string | undefined,
    accessibilities: raw.accessibilities as string | undefined,
    accessibility_sections: raw.accessibility_sections as string | undefined,
    zoom: raw.zoom as string | undefined,
    saved_place_id: raw.saved_place_id as string | undefined,
    saved_place_user_id: raw.saved_place_user_id as string | undefined,
    saved_place_sortby: raw.saved_place_sortby as string | undefined,
    placesToReplaceString: raw.placesToReplaceString as string | undefined,
    simpleLocationText: raw.simpleLocationText as string | undefined,
    includeGoogleFallback: raw.includeGoogleFallback as string | undefined,
    openingHoursMode: raw.openingHoursMode as
      | "any"
      | "open_now"
      | "custom"
      | undefined,
    openingHoursDay: raw.openingHoursDay as string | undefined,
    openingHoursTime: raw.openingHoursTime as string | undefined,
    section_filter: raw.section_filter as string | undefined,
    mapper_category: raw.mapper_category as string | undefined,
  };
}
